import { combineReducers } from 'redux';
import { insurerReducer } from './Insurer';
import { provinceReducer } from './Province';
import { orderTemplateReducer } from './OrderTemplate';
import { companyReducer } from './Company';
import { healthPlanReducer } from './HealthPlan';
import { userReducer } from './User';
import { benefitTemplateReducer } from './BenefitTemplate';

export default combineReducers({
  insurerReducer,
  provinceReducer,
  orderTemplateReducer,
  companyReducer,
  healthPlanReducer,
  userReducer,
  benefitTemplateReducer,
});
